import { useEffect } from 'react';
import { BRAND } from '../data/brand';

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function useDocumentMeta(pageLabel: string | null, path: string) {
  useEffect(() => {
    const title = pageLabel ? `${pageLabel} — ${BRAND.name}` : BRAND.title;
    document.title = title;
    setMeta('name', 'description', BRAND.description);
    setMeta('property', 'og:site_name', BRAND.name);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', BRAND.description);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:url', `${BRAND.url}${path}`);
    setMeta('name', 'twitter:card', 'summary');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', BRAND.description);
  }, [pageLabel, path]);
}
